import { render, staticRenderFns } from "./NewsDetailView.vue?vue&type=template&id=4a52352b"
import script from "./NewsDetailView.vue?vue&type=script&lang=js"
export * from "./NewsDetailView.vue?vue&type=script&lang=js"
import style0 from "./NewsDetailView.vue?vue&type=style&index=0&id=4a52352b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports